import PropTypes from "prop-types"

import PeriodSelectionHOC from "../period_selection_hoc"
import ServiceStats from "./service_stats"
import categoryDetailTopServicesFetcher from "./category_detail_top_services_fetcher"

const TopServicesBasic = ({
  data: { worksWithData, firstTimeUsers },
  serviceName,
  timePeriodInDays,
  servicesUrl,
  onDetailSelect,
}) => (
  <>
    <div className="connected-services-list">
      {worksWithData.map((svcData, i) => (
        <ServiceStats
          data={svcData}
          serviceName={serviceName}
          totalUsersThisPeriod={firstTimeUsers}
          key={i}
          timePeriodInDays={timePeriodInDays}
          url={
            servicesUrl != null && svcData.channel
              ? `${servicesUrl}/${svcData.channel.module_name}`
              : "#"
          }
          onDetailSelect={servicesUrl == null ? onDetailSelect : null}
        />
      ))}
    </div>
  </>
)

TopServicesBasic.propTypes = {
  data: PropTypes.shape({
    worksWithData: PropTypes.array,
    firstTimeUsers: PropTypes.number,
    firstTimeUsersLastPeriod: PropTypes.number,
    totalServices: PropTypes.number,
    totalServicesLastPeriod: PropTypes.number,
  }),
  serviceName: PropTypes.string.isRequired,
  timePeriodInDays: PropTypes.number.isRequired,
  onDetailSelect: PropTypes.func,
  servicesUrl: PropTypes.string,
}

export default PeriodSelectionHOC({
  WrappedComponent: TopServicesBasic,
  serviceMetricsFetcher: categoryDetailTopServicesFetcher,
  headerText: "Services connected",
  subHeaderText: "The top services connected",
  fetchDailyComparisonData: true,
  topServicesLimit: 4,
})
